import { inject } from '@angular/core'
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { map } from 'rxjs/operators'
import { AuthService } from './auth.service'

export const RedirectGuard: CanActivateFn = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
  const authService = inject(AuthService)
  const router = inject(Router)

  return authService.tryRestoreSession().pipe(
    map(authenticated => {
      if (authenticated) return router.parseUrl('/home')

      // AuthGuard lands here as `/?returnUrl=…` when a guarded deep link finds
      // no session. A bare parseUrl('/login') redirect drops that query — the
      // login page then has no idea where to send the user back (the OAuth
      // consent page is the flow that cannot survive losing it, since the
      // client's whole request lives in that URL).
      const returnUrl = route.queryParams['returnUrl']
      return returnUrl ? router.createUrlTree(['/login'], { queryParams: { returnUrl } }) : router.parseUrl('/login')
    }),
  )
}
